import { render } from "./InputImage.vue?vue&type=template&id=5110ab56&ts=true"
import script from "./InputImage.vue?vue&type=script&lang=ts"
export * from "./InputImage.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__